import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { cloneElement } from 'react';
import Box from '../Box';
import { getForegroundColor, useBoxSize, useThemeProps } from '../system';
import StackView from '../StackView';
import Text from '../Text';
import { stopPropagationClick } from '../utils';

function Badge(_ref) {
  var children = _ref.children,
      renderLeft = _ref.renderLeft,
      renderRight = _ref.renderRight,
      onClick = _ref.onClick,
      title = _ref.title,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "renderLeft", "renderRight", "onClick", "title"]);

  var _useThemeProps = useThemeProps('badge', restProps),
      _useThemeProps$color = _useThemeProps.color,
      color = _useThemeProps$color === void 0 ? {
    foreground: 'foreground',
    background: 'surfaceTertiary'
  } : _useThemeProps$color,
      _useThemeProps$radius = _useThemeProps.radius,
      radius = _useThemeProps$radius === void 0 ? 3 : _useThemeProps$radius,
      _useThemeProps$size = _useThemeProps.size,
      size = _useThemeProps$size === void 0 ? 'md' : _useThemeProps$size,
      _useThemeProps$square = _useThemeProps.square,
      square = _useThemeProps$square === void 0 ? false : _useThemeProps$square,
      themeProps = _objectWithoutPropertiesLoose(_useThemeProps, ["color", "radius", "size", "square"]);

  var badgeProps = _objectSpread({
    color: color,
    radius: radius,
    size: size,
    square: square
  }, themeProps);

  badgeProps.backgroundColor = color.background || color;
  badgeProps.color = color.foreground || getForegroundColor(color);

  var _useBoxSize = useBoxSize(badgeProps.size),
      boxSize = _useBoxSize.boxSize,
      fontSize = _useBoxSize.fontSize,
      lineHeight = _useBoxSize.lineHeight,
      paddingHorizontal = _useBoxSize.paddingHorizontal,
      paddingHorizontalDense = _useBoxSize.paddingHorizontalDense,
      paddingVertical = _useBoxSize.paddingVertical;

  var textStyle = {
    as: 'span',
    fontWeight: 'inherit',
    lineHeight: 'inherit',
    color: 'inherit'
  };

  if (badgeProps.square || badgeProps.radius === 'circle') {
    badgeProps.width = boxSize;
    badgeProps.height = boxSize;
  }

  if (badgeProps.radius === 'circle') {
    textStyle.position = 'absolute';
    textStyle.top = '50%';
    textStyle.left = '50%';
    textStyle.transform = 'translate(-50%, -50%)';
  }

  badgeProps.paddingLeft = renderLeft ? boxSize + 0.5 : badgeProps.radius === 'pill' ? paddingHorizontal : paddingHorizontalDense;
  badgeProps.paddingRight = renderRight ? boxSize + 0.5 : badgeProps.radius === 'pill' ? paddingHorizontal : paddingHorizontalDense; // The `square` prop is no longer needed and should not get
  // passed to `<StackView>` since it's not one of its props
  // or a standard HTML attribute.

  delete badgeProps.square;
  return /*#__PURE__*/React.createElement(StackView, _extends({
    inline: true,
    axis: "horizontal",
    alignment: "center",
    distribution: "center",
    fontSize: fontSize,
    lineHeight: lineHeight,
    minHeight: boxSize,
    paddingVertical: paddingVertical,
    fill: "currentColor",
    textAlign: "center",
    position: "relative",
    cursor: "default",
    outline: 0,
    focus: {
      backgroundColor: 'highlightSecondary'
    },
    onClick: stopPropagationClick(onClick)
  }, badgeProps), renderLeft && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: boxSize,
    height: boxSize,
    position: "absolute",
    top: 0,
    left: 0
  }, typeof renderLeft === 'string' ? renderLeft : /*#__PURE__*/cloneElement(renderLeft, {
    size: renderLeft.props && renderLeft.props.size || badgeProps.size
  })), typeof title === 'undefined' ? children : /*#__PURE__*/React.createElement(Text, textStyle, title), renderRight && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: boxSize,
    height: boxSize,
    position: "absolute",
    top: 0,
    right: 0
  }, typeof renderRight === 'string' ? renderRight : /*#__PURE__*/cloneElement(renderRight, {
    size: renderRight.props && renderRight.props.size || badgeProps.size
  })));
}

export default Badge;